import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSettingsMenuComponent } from '@app/pcs/header/app-settings-menu/app-settings-menu.component';
import { HeaderComponent } from '@app/pcs/header/header.component';
import { HelpMenuComponent } from '@app/pcs/header/help-dropdown/help-menu.component';
import { MainMenuComponent } from '@app/pcs/header/main-menu/main-menu.component';
import { MenuDropdownComponent } from '@app/pcs/header/menu-dropdown/menu-dropdown.component';
import { UserSettingsMenuComponent } from '@app/pcs/header/user-settings-menu/user-settings-menu.component';
import { PcsSharedModule } from '@app/pcs/shared/pcs-shared.module';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PcsSharedModule,
    RouterModule
  ],
  declarations: [
    HeaderComponent,
    MainMenuComponent,
    MenuDropdownComponent,
    UserSettingsMenuComponent,
    HelpMenuComponent,
    AppSettingsMenuComponent
  ],
  providers: [],
  exports: [
    HeaderComponent,
    MainMenuComponent,
    AppSettingsMenuComponent,
    UserSettingsMenuComponent,
    HelpMenuComponent
  ]
})
export class HeaderModule {
}
